import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f5e7b7fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "disabled", "aria-label"]

import { computed, ref } from "vue";
import { saveGoalInput } from "../../stores/goal-capture-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'goal-capture-box',
  props: {
    label: {},
    goalNumber: {},
    text: {},
    locked: { type: Boolean }
  },
  emits: ["update:goalName"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable */
const props = __props;
const text = ref<string>("Loading...");
const loading = ref<boolean>(true);

const id = computed(() => `goal-capture-box-${props.goalNumber}`);

const emit = __emit;

const syncedText = computed({
  get: () => props.text,
  set: (newValue) => {
    emit("update:goalName", newValue);
  },
});

const blur = () => saveThrottled(true);

const paste = () => {
  saveThrottled(true);
};

const keyDown = (e: KeyboardEvent) => {
  if (e.key === "Enter" || e.key === "!" || e.key === "." || e.key === "?") {
    setTimeout(() => {
      saveThrottled(true);
    }, 100);
  } else {
    setTimeout(() => {
      saveThrottled(false);
    }, 100);
  }
};

let inputTimeout = null;

async function saveThrottled(rerunPrompts: boolean) {
  if (inputTimeout !== null) {
    return;
  }

  inputTimeout = setTimeout(async () => {
    inputTimeout = null;
    saveGoalInput(syncedText.value, props.goalNumber, rerunPrompts);
  }, 1000) as any;
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    class: "form-control",
    id: id.value,
    disabled: props.locked,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((syncedText).value = $event)),
    placeholder: "Type something...",
    "aria-label": props.label ?? 'goal text box',
    rows: "3",
    onBlur: blur,
    onPaste: blur,
    onKeydown: _withModifiers(keyDown, ["stop"]),
    "data-test": "goal-capture-box"
  }, null, 40, _hoisted_1)), [
    [_vModelText, syncedText.value]
  ])
}
}

})